import { Phone, Mail, MapPin } from "lucide-react";
import WhatsAppIcon from "@/components/WhatsAppIcon";

const Contact = () => {
  const contactMethods = [
    {
      icon: WhatsAppIcon,
      label: "WhatsApp",
      value: "+852 9025 9921",
      href: "https://wa.me/85290259921",
      primary: true,
    },
    {
      icon: Phone,
      label: "Phone",
      value: "+852 9025 9921",
      href: "tel:+85290259921",
      primary: false,
    },
    {
      icon: Mail,
      label: "Email",
      value: "info@rlxhk.com",
      href: "mailto:info@rlxhk.com",
      primary: false,
    },
  ];

  return (
    <section id="contact" className="section-padding bg-section-alt">
      <div className="container-padding max-w-7xl mx-auto">
        <div className="text-center mb-16 md:mb-20">
          <p className="text-eyebrow font-medium text-sm mb-4">Get In Touch</p>
          <h2 className="heading-lg text-foreground mb-6">Let's start your project</h2>
          <p className="text-body max-w-2xl mx-auto">
            Ready to bring your ideas to life? We'd love to hear from you. Reach out and let's discuss how we can help
            your business grow.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
            {contactMethods.map((method) => (
              <a
                key={method.label}
                href={method.href}
                target={method.label === "WhatsApp" ? "_blank" : undefined}
                rel={method.label === "WhatsApp" ? "noopener noreferrer" : undefined}
                className={`flex flex-col items-center p-8 rounded-2xl border transition-all duration-300 hover-lift ${
                  method.primary
                    ? "bg-primary text-primary-foreground border-primary"
                    : "bg-card border-border hover:border-primary/30"
                }`}
              >
                <method.icon className={`w-8 h-8 mb-4 ${method.primary ? "" : "text-primary"}`} aria-hidden="true" focusable="false" />
                <p className={`font-medium mb-1 ${method.primary ? "text-[#0a140e]" : "text-foreground"}`}>{method.label}</p>
                <p className={`text-sm ${method.primary ? "text-[#0a140e]" : "text-muted-foreground"}`}>{method.value}</p>
              </a>
            ))}
          </div>

          <div className="bg-card border border-border rounded-2xl p-8 md:p-10">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                <MapPin className="w-6 h-6 text-primary" aria-hidden="true" focusable="false" />
              </div>
              <div>
                <h3 className="text-xl font-semibold text-foreground mb-2">Visit Our Office</h3>
                <p className="text-muted-foreground">
                  Room 1209, Inter-Continental Plaza,
                  <br />
                  94 Granville Road,
                  <br />
                  Tsim Sha Tsui East, Hong Kong
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
